module.exports = __webpack_public_path__ + "static/media/ticktick.6a0f2b08.mp3";